
import { ReactComponent as CheckCircle } from "@/assets/svgs/DesignSystem/check-circle.svg";
import { ReactComponent as CheckHistory } from "@/assets/svgs/DesignSystem/check-history.svg";
import { ReactComponent as Clock } from "@/assets/svgs/DesignSystem/clock.svg";
import { ReactComponent as ExclamationCircle } from "@/assets/svgs/DesignSystem/exclamation-circle.svg";
import { ReactComponent as XCircle } from "@/assets/svgs/DesignSystem/x-circle.svg";
import { ReactComponent as CheckDouble } from "@/assets/svgs/DesignSystem/check-double.svg";
import { ReactComponent as ArrowDownCircle } from "@/assets/svgs/DesignSystem/arrow-down-circle.svg";
import { ReactComponent as Flag } from "@/assets/svgs/DesignSystem/flag.svg";
import Tags from "./Tags";
import PropTypes from 'prop-types';

export const STATUS = {
	SENT : 'SENT',
	FAILED : 'FAILED',
	EXPIRED : 'EXPIRED',
	PENDING_APPROVAL : 'PENDING_APPROVAL',
	REJECTED : 'REJECTED',
	APPROVED : 'APPROVED',
	RECEIVED : 'RECEIVED',
	NEW_DATA : 'NEW_DATA',
	IN_PROGRESS : 'IN_PROGRESS',
	SENDING : 'SENDING',
	ISSUED : 'ISSUED',
	DRAFT : 'DRAFT',
	SURRENDERED : 'SURRENDERED',
	SHREDDED : 'SHREDDED',
	NOMINATED : 'NOMINATED',
	COPY_SUCCESS : 'COPY_SUCCESS',
	COPY_FAILED : 'COPY_FAILED',
}


const statusTagProperties = {
	[STATUS.SENT]:{
		label:"Sent",
		prefixIcon:<CheckCircle />,
		tagClassName: 'DS__tag--success'
	},
	[STATUS.FAILED]:{
		label:"Failed ",
		prefixIcon:<ExclamationCircle />,
		tagClassName: 'DS__tag--critical'
	},
	[STATUS.EXPIRED]:{
		label:"Expired",
		prefixIcon:<Clock />,
		tagClassName: 'DS__tag--neutral'
	},
	[STATUS.PENDING_APPROVAL]:{
		label:"Pending Approval",
		prefixIcon:<CheckHistory />,
		tagClassName: 'DS__tag--warning'
	},
	[STATUS.REJECTED]:{
		label:"Rejected",
		prefixIcon:<XCircle />,
		tagClassName: 'DS__tag--critical'
	},
	[STATUS.APPROVED]:{
		label:"Approved",
		prefixIcon:<CheckDouble />,
		tagClassName: 'DS__tag--success'
	},
	[STATUS.RECEIVED]:{
		label:"Received",
		prefixIcon:<CheckCircle />,
		tagClassName: 'DS__tag--success'
	},
	[STATUS.NEW_DATA]:{
		label:"New Data",
		prefixIcon:<ArrowDownCircle />,
		tagClassName: 'DS__tag--new'
	},
	[STATUS.IN_PROGRESS]:{
		label:"In Progress",
		prefixIcon:<Clock />,
		tagClassName: 'DS__tag--system'
	},
	[STATUS.SENDING]:{
		label:"Sending...",
		prefixIcon:<CheckHistory />,
		tagClassName: 'DS__tag--system'
	},
	[STATUS.ISSUED]:{
		label:"Issued",
		prefixIcon:<CheckCircle />,
		tagClassName: 'DS__tag--success'
	},
	[STATUS.DRAFT]:{
		label:"Draft",
		prefixIcon:<CheckHistory />,
		tagClassName: 'DS__tag--system'
	},
	[STATUS.SURRENDERED]:{
		label:"Surrendered",
		prefixIcon:<Flag />,
		tagClassName: 'DS__tag--warning'
	},
	[STATUS.SHREDDED]:{
		label:"Shredded",
		prefixIcon:<XCircle />,
		tagClassName: 'DS__tag--neutral'
	},
	[STATUS.NOMINATED]:{
		label:"Nominated",
		prefixIcon:<Clock />,
		tagClassName: 'DS__tag--new'
	},
	[STATUS.COPY_SUCCESS]:{
		label:"Consumer",
		prefixIcon:<CheckCircle />,
		tagClassName: 'DS__tag--success'
	},
	[STATUS.COPY_FAILED]:{
		label:"Consumer",
		prefixIcon:<ExclamationCircle />,
		tagClassName: 'DS__tag--critical'
	},
}

const StatusTags = ({ status }) => {
	return <Tags dataTestId={'status-tag'} {...statusTagProperties[status]} />;
};

StatusTags.propTypes = {
	status: PropTypes.string
};

export default StatusTags;



